import React, { useMemo } from 'react';
import { createColumnHelper, RowData } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { getWeekdayDateFormat } from '../../../../utils/date';
import { compareDates } from '../../../../utils/sort';
import Table from './Table';
import moment from 'moment';

export type DocumentDataEntry = {
	creationDate: string;
	fileName: string;
	id: number;
	storageBucketIdentifier: string;
};

type Props = { documents: DocumentDataEntry[]; handleRowClick: (row: RowData) => void };

const columnHelper = createColumnHelper<DocumentDataEntry>();
const DocumentsOverview = ({ documents, handleRowClick }: Props) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() => [
			columnHelper.accessor('fileName', {
				header: t('documents.name'),
			}),
			columnHelper.accessor('creationDate', {
				header: t('documents.date'),
				cell: ({ row }) => {
					const { original } = row;
					return getWeekdayDateFormat(original?.creationDate);
				},
				sortingFn: (rowA, rowB) =>
					compareDates(moment(rowA.original.creationDate), moment(rowB.original.creationDate)),
			}),
		],
		[t],
	);

	return <Table data={documents} columns={columns} handleRowClick={handleRowClick} />;
};

export default DocumentsOverview;
